import script from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminIndex.css?vue&type=style&index=0&id=1d7710cd&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7710cd"]])

export default __exports__